import { API, unwrapData } from '../axios-instance'
import { PageResult } from '../shared'
import {
  ArchiveAwardTypeParams,
  AwardType,
  AwardTypeParams,
  AwardTypeRecipient,
  GetAwardTypeParams,
  ListAwardTypeParams,
  ListAwardTypeRecipientsParams,
  MyAwardType,
  MyAwardsSummary,
  PreviewAwardTypeParams,
  PreviewAwardTypeResults,
} from './types'

export const createAwardType = async (params: AwardTypeParams) => {
  return await API.post<AwardType>('/award/awardTypes', params).then(unwrapData)
}
export const editAwardType = async (awardId: string, params: AwardTypeParams) => {
  return await API.put<AwardType>(`/award/awardTypes/${awardId}`, params).then(unwrapData)
}

export const listAwardTypes = async (params: ListAwardTypeParams) => {
  return await API.get<PageResult<AwardType>>('/award/awardTypes', { params }).then(unwrapData)
}

export const getAwardType = async (awardTypeId: string, params: GetAwardTypeParams) => {
  return await API.get<AwardType>(`/award/awardTypes/${awardTypeId}`, { params }).then(unwrapData)
}

export const listAwardTypeRecipients = async (
  awardTypeId: string,
  params: ListAwardTypeRecipientsParams,
) => {
  return await API.get<PageResult<AwardTypeRecipient>>(
    `/award/awardTypes/${awardTypeId}/recipients`,
    {
      params,
    },
  ).then(unwrapData)
}

export const exportAwardsTypeRecipientsCsv = async (
  awardTypeId: string,
  params: ListAwardTypeRecipientsParams,
) => {
  return await API.post<BlobPart>(`/award/awardTypes/${awardTypeId}/recipients/export`, params, {
    params: { sorting: params.sorting },
  }).then(unwrapData)
}

export const archiveAwardType = async (awardTypeId: string, params: ArchiveAwardTypeParams) => {
  return await API.patch<AwardType>(`/award/awardTypes/${awardTypeId}`, params).then(unwrapData)
}

export const cloneAwardType = async (awardTypeId: string) => {
  return await API.post<AwardType>(`/award/awardTypes/${awardTypeId}/clone`).then(unwrapData)
}

export const myAwardTypes = async (params: ListAwardTypeParams) => {
  return await API.get<PageResult<MyAwardType>>('/awards/awardTypes/my', { params }).then(
    unwrapData,
  )
}

export const previewAwardType = async (params: PreviewAwardTypeParams) => {
  return await API.post<PreviewAwardTypeResults>(
    `/awards/awardTypes/${params.awardTypeId}/preview`,
    params,
  ).then(unwrapData)
}

export const getMyAwardsSummary = async () => {
  return await API.get<MyAwardsSummary[]>('/award/awardTypes/summary').then(unwrapData)
}
